var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M12.375 2c.83 0 1.5.671 1.5 1.5v5.25a1.5 1.5 0 0 1-1.5 1.5H10.25v2.125a1.5 1.5 0 0 1-1.355 1.494l-.145.006H3.5a1.5 1.5 0 0 1-1.5-1.5v-5.25c0-.829.67-1.5 1.5-1.5h2.125V3.5c0-.829.67-1.5 1.5-1.5h5.25zm-6.75 4.625H3.5a.5.5 0 0 0-.5.5v5.25a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5V10.25H7.125a1.5 1.5 0 0 1-1.5-1.5V6.625zM12.375 3h-5.25a.5.5 0 0 0-.5.5v5.25a.5.5 0 0 0 .5.5H9.75a.51.51 0 0 1 .01 0h2.615a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5z"
  })));
};
export default SvgCopy;